<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div *ngIf="serverError === null">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/admin" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('staff-site-settings');$event.preventDefault();"
           [class.active]="currentSectionId === 'staff-site-settings'">
          Staff Site Settings
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('climber-app-settings');$event.preventDefault();"
           [class.active]="currentSectionId === 'climber-app-settings'">
          Climber App Settings
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('integrations');$event.preventDefault();"
           [class.active]="currentSectionId === 'integrations'">
          Integrations
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit || loadingAnyClearConnection()"
              [disabled]="loadingSubmit || loadingAnyClearConnection()"
              type="button" (click)="saveOrganizationSettings()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content" appScrollDetect>
    <div class="pt-4 pl-md-4 mb-6">
      <div class="floating-alert-container">
        <div class="alert alert-dismissible" role="alert"
             [class.alert-success]="modalResult.status === CallbackResultStatus.success"
             *ngIf="modalResult !== null">
          {{ modalResult.text }}
          <button type="button" class="close" (click)="modalResult = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

      <h2 class="mb-3">
        Organization Settings
        <span *ngIf="loadingOrgConfig" class="text-muted"> - Loading...</span>
      </h2>

      <ng-container *ngIf="!loadingOrgConfig">
        <div appScrollSpy [spiedTags]="['H3']" (sectionChange)="onSectionChange($event)">
          <h3 id="staff-site-settings">Staff Site Settings</h3>

          <form (submit)="saveOrganizationSettings();$event.preventDefault();" *ngIf="orgConfig">
            <div class="form-group">
              <label for="pinTimeoutSecondsInput">PIN timeout (seconds) *</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="pinTimeoutSecondsInput" type="number" name="pin_timeout_seconds"
                         min="1" max="3600" step="1"
                         class="form-control"
                         [(ngModel)]="orgConfig.pin_timeout_seconds"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This is the number of seconds which a PIN will be retained when in PIN Mode. Any actions taken after this timeout will prompt the user to enter their PIN again.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.pin_timeout_seconds }}</div>
            </div>

            <div class="form-group">
              <label for="firstDaySelect">Reporting First Day of Week</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <select id="firstDaySelect" class="custom-select"
                          name="firstDay"
                          [(ngModel)]="orgConfig.reporting_first_day_of_week"
                          (ngModelChange)="unsavedChanges = true">
                    <option value="{{ ReportingFirstDayOfWeek.sunday }}">Sunday</option>
                    <option value="{{ ReportingFirstDayOfWeek.monday }}">Monday</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">
                {{ orgConfigErrors.reporting_first_day_of_week }}
              </div>
              <small class="form-text text-muted">
                When generating reports with a weekly interval, Capitan will start the week on this day.
              </small>
            </div>

            <div class="form-group">
              <label for="inboxItemMaxAgeMonthsInput"># of months before inbox items are automatically removed</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="inboxItemMaxAgeMonthsInput" type="number" name="inbox_item_max_age_months"
                         min="1" step="1"
                         class="form-control"
                         [(ngModel)]="orgConfig.inbox_item_max_age_months"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                Leave this blank in order to keep inbox items indefinitely.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.inbox_item_max_age_months }}</div>
            </div>

            <div class="form-group">
              <label for="customer_search_recent_activity_window_months">
                To optimize search performance on the Staff Site, what recent activity filter should be applied?
              </label>
              <div class="row">
                <div class="col-lg-5 col-md-8 col-sm-12">
                  <select id="customer_search_recent_activity_window_months"
                          name="customer_search_recent_activity_window_months"
                          class="custom-select"
                          [(ngModel)]="orgConfig.customer_search_recent_activity_window_months"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="3">Customers with activity within 3 months</option>
                    <option [ngValue]="6">Customers with activity within 6 months</option>
                    <option [ngValue]="9">Customers with activity within 9 months</option>
                    <option [ngValue]="12">Customers with activity within 12 months</option>
                    <option [ngValue]="null">All customers (no filter)</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Selecting a shorter window will improve search performance. <i>Activity</i> is defined as any Capitan action (checking in, completing a document, making a purchase, etc.) made by the customer or by staff on their behalf.
                <br>
                This setting does not remove customers outside of the selected window; it only filters search results. Staff can still expand the search to include all customers if needed.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.customer_search_recent_activity_window_months }}</div>
            </div>

            <div class="form-group">
              <label for="lapsed_customer_guest_pass_window_months">
                For "lapsed customers only" guest passes, how many months without a check-in make a customer eligible?
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input type="number"
                         id="lapsed_customer_guest_pass_window_months"
                         name="lapsed_customer_guest_pass_window_months"
                         min="1" max="120" step="1"
                         class="form-control"
                         [(ngModel)]="orgConfig.lapsed_customer_guest_pass_window_months"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                A "lapsed customers only" guest pass may be used by a customer who has never checked in, or whose most recent check-in at any of your locations was more than this many months ago. Changing this value applies immediately to every outstanding lapsed-customer guest pass. Guest passes are granted by membership types (under Benefits) or added manually from a customer's profile.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.lapsed_customer_guest_pass_window_months }}</div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="allow_offline_payments" id="allowOfflinePaymentsInput"
                       [(ngModel)]="orgConfig.allow_offline_payments"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="allowOfflinePaymentsInput">
                  Allow offline payments
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.allow_offline_payments }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, staff may record offline payments, such as the "Mark event as paid offline" option on private events. Deselect this option if every payment at your organization should be processed through Capitan or your integrated point of sale software.
              </small>
            </div>
          </form>

          <hr>

          <h3 id="climber-app-settings">Climber App Settings</h3>

          <form (submit)="saveOrganizationSettings();$event.preventDefault();" *ngIf="orgConfig">
            <div class="form-group">
              <label for="loginMinAgeInput">Minimum age for having a Capitan customer-facing account *</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="loginMinAgeInput" type="number" name="customer_login_minimum_age"
                         min="13" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="orgConfig.customer_login_minimum_age"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                If a customer is under this age, their email address will not be required when filling out a document. A customer under this age will not be able to create a Capitan login to manage their membership, book a class, etc.
                This will not impact someone over this age managing a younger customer's linked account (e.g. a linked parent managing their child's account).
                This must be set to an age 13 or older.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.customer_login_minimum_age }}</div>
            </div>

            <div class="form-group">
              <label for="membershipMinAgeInput">Minimum age to own a membership (optional)</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="membershipMinAgeInput" type="number" name="membership_minimum_age"
                         min="1" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="orgConfig.membership_minimum_age"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                If set, customers younger than this age will not be able to purchase a membership.
                Instead, their membership must be owned by a linked customer of sufficient age.
                Leave blank for no restriction.
                <br>
                <span class="text-warning">
                  This setting only applies to newly-purchased memberships.
                  Your existing memberships will not be affected if the setting is changed.
                </span>
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.membership_minimum_age }}</div>
            </div>

            <div class="indented-subsection" *ngIf="orgConfig.membership_minimum_age">
              <div class="form-group">
                <label for="membershipMinAgeAppliesToPrepaidSelect">Does this restriction apply to prepaid memberships?</label>
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-5">
                    <select id="membershipMinAgeAppliesToPrepaidSelect" name="membership_minimum_age_applies_to_prepaid"
                            class="form-control"
                            [(ngModel)]="orgConfig.membership_minimum_age_applies_to_prepaid"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="false">No</option>
                      <option [ngValue]="true">Yes</option>
                    </select>
                  </div>
                </div>
                <div class="form-text text-danger">{{ orgConfigErrors.membership_minimum_age_applies_to_prepaid }}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="displayEmailOptInSelect">Display Email Opt-In</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <select id="displayEmailOptInSelect" name="display_email_opt_in"
                          class="form-control"
                          [(ngModel)]="orgConfig.display_email_opt_in"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "No", then the email opt-in field will not be shown in the Climber App "Settings" page or the Staff Site "Edit Customer Profile" page.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.display_email_opt_in }}</div>
            </div>

            <div class="indented-subsection" *ngIf="orgConfig.display_email_opt_in">
              <div class="form-group">
                <label for="email_opt_in_is_selected_by_default">Select Email Opt-In By Default</label>
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-5">
                    <select id="email_opt_in_is_selected_by_default" name="email_opt_in_is_selected_by_default"
                            class="form-control"
                            [(ngModel)]="orgConfig.email_opt_in_is_selected_by_default"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If this is set to "Yes", then the email opt-in checkbox will be checked by default when filling out a document. The customer will have to uncheck the box in order to opt out.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.email_opt_in_is_selected_by_default }}</div>

                <div class="alert alert-info">
                  Local regulations may affect whether you are allowed to opt customers into email marketing by default. It is your organization's responsibility to follow applicable rules around email marketing. Failing to do so may cause your marketing integrations to be impacted.
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-10 col-lg-8 col-xl-6">
                  <a href="#" class="float-right"
                     (click)="openPreviewEmailOptInModal();$event.preventDefault();">
                    Preview Email Opt-In
                  </a>
                  <label>Email Opt-In Checkbox Text</label>
                  <app-markdown-editor-single-line [id]="'emailOptInCheckboxText'"
                                                   [(content)]="orgConfig.email_opt_in_checkbox_text"
                                                   (contentChange)="unsavedChanges = true"></app-markdown-editor-single-line>
                  <small class="form-text text-muted">This is shown next to the email opt-in checkbox in the Climber App Settings page, and in any documents which are configured to display the email opt-in checkbox.</small>
                  <div class="form-text text-danger">{{ orgConfigErrors.email_opt_in_checkbox_text }}</div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-10 col-lg-8 col-xl-6">
                  <label>Email Opt-In Help Text</label>
                  <app-markdown-editor [id]="'emailOptInHelpText'"
                                       [(content)]="orgConfig.email_opt_in_help_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">This is shown beneath the email opt-in checkbox in the Climber App Settings page, and in any documents which are configured to display the email opt-in checkbox.</small>
                  <div class="form-text text-danger">{{ orgConfigErrors.email_opt_in_help_text }}</div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-10 col-lg-8 col-xl-6">
                <label>"Select Document" Page Welcome Text</label>
                <app-markdown-editor [id]="'selectDocumentPageWelcomeText'"
                                     [(content)]="orgConfig.select_document_page_text"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This is shown at the top of the "Select Document" page in the Climber App.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.select_document_page_text }}</div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-10 col-lg-8 col-xl-6">
                <label>Additional Capitan Invite Email Text</label>
                <app-markdown-editor [id]="'invite_email_additional_text'"
                                     [(content)]="orgConfig.invite_email_additional_text"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This is included at the bottom of Climber App invite emails sent to new customers.
                </small>
                <button type="button"
                        class="btn btn-sm btn-outline-primary mt-2"
                        (click)="openInviteEmailPreviewModal()">
                  Preview Invite Email
                </button>
                <div class="form-text text-danger">{{ orgConfigErrors.invite_email_additional_text }}</div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-10 col-lg-8 col-xl-6">
                <label for="googleAnalytics4MeasurementIdInput">Google Analytics 4 Measurement ID</label>
                <input class="form-control" id="googleAnalytics4MeasurementIdInput"
                       name="google_analytics_4_measurement_id"
                       [(ngModel)]="orgConfig.google_analytics_4_measurement_id"
                       (ngModelChange)="unsavedChanges = true">
                <small class="form-text text-muted">
                  This must be the "G-" Measurement ID of a GA4 Web Stream. Refer to the
                  <a href="https://support.google.com/analytics/answer/9304153?hl=en#zippy=%2Cweb%2Cfind-your-g--id-for-any-platform-that-accepts-a-g--id"
                     target="_blank">
                    Google Analytics documentation
                  </a>
                  for instructions on creating a Web Stream and obtaining its Measurement ID.
                </small>
                <small class="form-text text-muted">
                  To learn more, see our
                  <a href="https://capitan.helpscoutdocs.com/article/174-google-analytics-ecommerce-tracking"
                     target="_blank">
                    support article on the Google Analytics integration</a>.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.google_analytics_4_measurement_id }}</div>
              </div>
            </div>

            <div class="form-group indented-subsection" *ngIf="orgConfig.google_analytics_4_measurement_id">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="google_analytics_user_data_enabled"
                       id="google_analytics_user_data_enabled"
                       [(ngModel)]="orgConfig.google_analytics_user_data_enabled"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="google_analytics_user_data_enabled">
                  Send customer info to Google Analytics
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.google_analytics_user_data_enabled }}</div>
              </div>
              <small class="form-text text-muted">
                Sends Google Analytics the customer's email address, name and customer ID with each tracked event, plus their phone number when they are signed in. Google uses this to match more of your conversions to the people who saw your ads, and to recognize the same customer across devices.
              </small>
              <small class="form-text text-muted">
                This has no effect until you also turn on "Allow user-provided data capabilities" in Google Analytics (Admin, Data streams, your web stream, Google tag, Configure tag settings). Until then Google ignores what Capitan sends, with no warning in either system. See Google's
                <a href="https://support.google.com/analytics/answer/14078702?hl=en"
                   target="_blank">
                  guide to collecting user-provided data</a>.
              </small>
              <small class="form-text text-muted">
                Sending the customer ID switches the property to Google Analytics' User-ID reporting identity, which can change the user counts in your reports.
              </small>
              <small class="form-text text-muted">
                Disclosing this in your privacy policy is your responsibility.
              </small>

              <div class="form-group mt-3 mb-0">
                <label for="ga4_measurement_protocol_api_secret">Measurement Protocol API Secret</label>
                <div class="row">
                  <div class="col-md-10 col-lg-8 col-xl-6">
                    <input type="text" class="form-control" id="ga4_measurement_protocol_api_secret"
                           name="ga4_measurement_protocol_api_secret"
                           autocomplete="off"
                           [(ngModel)]="orgConfig.ga4_measurement_protocol_api_secret"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  Create an API secret in Google Analytics under Admin, Data collection and modification, Data streams, your web stream, Measurement Protocol API secrets. Refer to the
                  <a href="https://developers.google.com/analytics/devguides/collection/protocol/ga4/sending-events?client_type=gtag"
                     target="_blank">
                    Google Analytics Measurement Protocol documentation
                  </a>
                  for instructions on creating the secret.
                </small>
                <small class="form-text text-muted">
                  When this is set, Capitan also sends each purchase from the server, so purchases that an ad blocker or browser tracking prevention kept the browser from reporting are still counted. Clear the secret to turn server-side sending off.
                </small>
                <small class="form-text text-muted">
                  To verify the setup, make a test purchase and watch it appear in Google Analytics Realtime. Google accepts events sent with a wrong secret without reporting any error, so Capitan cannot warn you if the secret is incorrect.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.ga4_measurement_protocol_api_secret }}</div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-10 col-lg-8 col-xl-6">
                <label for="meta_pixel_id">Meta Pixel ID / Dataset ID</label>
                <input class="form-control" id="meta_pixel_id"
                       name="meta_pixel_id"
                       [(ngModel)]="orgConfig.meta_pixel_id"
                       (ngModelChange)="unsavedChanges = true">
                <small class="form-text text-muted">
                  This must be the ID of a Meta Pixel or Meta Dataset. Refer to the
                  <a href="https://www.facebook.com/business/help/952192354843755"
                     target="_blank">
                    Meta Business documentation
                  </a>
                  for instructions on creating a Meta Pixel.
                </small>
                <small class="form-text text-muted">
                  To learn more, see our
                  <a href="https://capitan.helpscoutdocs.com/article/276-meta-pixel-for-the-climber-app"
                     target="_blank">
                    support article on the Meta Pixel integration</a>.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.meta_pixel_id }}</div>
              </div>
            </div>

            <div class="form-group indented-subsection" *ngIf="orgConfig.meta_pixel_id">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="meta_pixel_advanced_matching_enabled"
                       id="meta_pixel_advanced_matching_enabled"
                       [(ngModel)]="orgConfig.meta_pixel_advanced_matching_enabled"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="meta_pixel_advanced_matching_enabled">
                  Send customer info to Meta for advanced matching
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.meta_pixel_advanced_matching_enabled }}</div>
              </div>
              <small class="form-text text-muted">
                Sends Meta the customer's email address, name and customer ID with each tracked event, plus their phone number when they are signed in. Meta uses this to match more of your conversions to the people who saw your ads, which improves the accuracy of your ad reporting.
              </small>

              <div class="form-group mt-3 mb-0">
                <label for="meta_capi_access_token">Conversions API Access Token</label>
                <div class="row">
                  <div class="col-md-10 col-lg-8 col-xl-6">
                    <input type="text" class="form-control" id="meta_capi_access_token"
                           name="meta_capi_access_token"
                           autocomplete="off"
                           [(ngModel)]="orgConfig.meta_capi_access_token"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  Generate an access token in Meta Events Manager, under the pixel's Settings, Conversions API. Refer to the
                  <a href="https://developers.facebook.com/docs/marketing-api/conversions-api/get-started/"
                     target="_blank">
                    Meta Conversions API documentation
                  </a>
                  for instructions on generating the token.
                </small>
                <small class="form-text text-muted">
                  When this is set, Capitan also sends ViewContent, InitiateCheckout and Purchase events from the server, deduplicated against the browser events. Clear the token to turn server-side sending off.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.meta_capi_access_token }}</div>

                <div class="alert alert-warning mt-2" role="alert" *ngIf="orgConfig.meta_capi_sync_error">
                  <b>This integration needs attention.</b>
                  Server-side sending is paused. {{ orgConfig.meta_capi_sync_error }}
                  <ng-container *ngIf="orgConfig.meta_capi_sync_error_timestamp">
                    ({{ orgConfig.meta_capi_sync_error_timestamp | date: 'medium' }})
                  </ng-container>
                  Enter a new access token to resume sending.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-10 col-lg-8 col-xl-6">
                <label for="climberAppEmbedScriptTextArea">Tracking/Analytics Script</label>
                <textarea class="form-control" id="climberAppEmbedScriptTextArea"
                          rows="4" name="climber_app_embed_script"
                          [(ngModel)]="orgConfig.climber_app_embed_script"
                          (ngModelChange)="unsavedChanges = true"></textarea>
                <small class="form-text text-muted">
                  This will be included in the <code>&lt;head&gt;</code> tag of each page of the Climber App. This may be used to include trackers for which Capitan does not have a specific integration.
                </small>
                <small class="form-text text-info">
                  For Google Analytics and Meta Pixel, there is no need to enter anything here. Instead, provide your ID in the appropriate setting above.
                </small>
                <div class="form-text text-danger">{{ orgConfigErrors.climber_app_embed_script }}</div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="restrict_climber_app_embedding"
                       id="restrict_climber_app_embedding"
                       [(ngModel)]="orgConfig.restrict_climber_app_embedding"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="restrict_climber_app_embedding">
                  Only allow specific websites to display the Climber App
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.restrict_climber_app_embedding }}</div>
              </div>
              <small class="form-text text-muted">
                The Climber App can be displayed inside a page on your own website. With this turned on, only the websites you list below can do that. With it turned off, any website can.
              </small>
            </div>

            <div class="form-group indented-subsection" *ngIf="orgConfig.restrict_climber_app_embedding">
              <label for="climberAppEmbedDomainsTextArea">Websites Allowed to Display the Climber App</label>
              <div class="row">
                <div class="col-md-10 col-lg-8 col-xl-6">
                  <textarea class="form-control" id="climberAppEmbedDomainsTextArea"
                            rows="4" name="climber_app_embed_domains"
                            [(ngModel)]="embedDomainsInput"
                            (ngModelChange)="unsavedChanges = true"></textarea>
                </div>
              </div>
              <small class="form-text text-muted">
                Enter one website address per line, exactly as it appears in the address bar but with no <code>https://</code> &mdash; for example <code>example.com</code>. Each address also covers its subdomains, so <code>example.com</code> allows <code>www.example.com</code> and <code>members.example.com</code> as well.
              </small>
              <small class="form-text text-muted">
                Leaving this empty means no other website can display the Climber App. Where the browser tells us enough, someone visiting a website that is not listed sees a message explaining that, along with a button to open the Climber App in a new tab; otherwise the Climber App simply does not appear on the page.
              </small>
              <small class="form-text text-info">
                This does not affect people using the Climber App directly, only websites displaying it inside one of their own pages.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.climber_app_embed_domains }}</div>
            </div>

            <div class="form-group">
              <label for="barcodePrefixInput">Barcode Prefix</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="barcodePrefixInput" type="text" name="barcode_prefix"
                         maxlength="6"
                         class="form-control"
                         [(ngModel)]="orgConfig.barcode_prefix"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This text will be included at the start of all generated customer barcodes. It may be up to 6 characters long.
              </small>
              <div class="form-text text-danger">{{ orgConfigErrors.barcode_prefix }}</div>
            </div>

            <div class="form-group">
              <label for="check_in_barcode_format">Barcode Format</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <select id="check_in_barcode_format"
                          name="check_in_barcode_format"
                          class="custom-select"
                          [(ngModel)]="orgConfig.check_in_barcode_format"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="BarcodeFormat.code128">Code 128 (Barcode)</option>
                    <option [ngValue]="BarcodeFormat.qrModel2">QR Code Model 2</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">{{ orgConfigErrors.check_in_barcode_format }}</div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="generate_barcodes_automatically" id="generateBarcodesAutomaticallyInput"
                       [(ngModel)]="orgConfig.generate_barcodes_automatically"
                       (ngModelChange)="onGenerateBarcodesAutomaticallyChange()">
                <label class="form-check-label" for="generateBarcodesAutomaticallyInput">
                  Generate customer barcodes automatically
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.generate_barcodes_automatically }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, a barcode will be automatically generated for each new customer account.
              </small>
            </div>

            <div class="form-group indented-subsection" *ngIf="orgConfig.generate_barcodes_automatically">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="limit_generated_barcodes_by_age" id="limitGeneratedBarcodesByAgeInput"
                       [(ngModel)]="orgConfig.limit_generated_barcodes_by_age"
                       (ngModelChange)="onLimitBarcodesByAgeChange()">
                <label class="form-check-label" for="limitGeneratedBarcodesByAgeInput">
                  Limit automatically generated barcode to customers over a certain age?
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.limit_generated_barcodes_by_age }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, a barcode will only be automatically generated for new customers who are at least the age below. Existing barcodes are not affected.
              </small>

              <div class="mt-3" *ngIf="orgConfig.limit_generated_barcodes_by_age">
                <label for="minimumBarcodeAgeInput">Minimum age</label>
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-5">
                    <input id="minimumBarcodeAgeInput" type="number" name="minimum_barcode_age"
                           min="1" max="120" step="1"
                           class="form-control"
                           [(ngModel)]="orgConfig.minimum_barcode_age"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <div class="form-text text-danger">{{ orgConfigErrors.minimum_barcode_age }}</div>
              </div>
            </div>

            <div class="form-group" *ngIf="orgConfig.pos_software !== OrgPOSSoftware.none">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="allow_pos_gift_card_usage" id="allowPosGiftCardUsageInput"
                       [(ngModel)]="orgConfig.allow_pos_gift_card_usage"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="allowPosGiftCardUsageInput">
                  Allow
                  <span *ngIf="orgConfig.pos_software === OrgPOSSoftware.square">Square</span>
                  <span *ngIf="orgConfig.pos_software === OrgPOSSoftware.lightspeed">Lightspeed</span>
                  gift cards to be used for Capitan purchases
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.allow_pos_gift_card_usage }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, customers may use
                <span *ngIf="orgConfig.pos_software === OrgPOSSoftware.square">Square</span>
                <span *ngIf="orgConfig.pos_software === OrgPOSSoftware.lightspeed">Lightspeed</span>
                gift cards to make purchases in the Climber App.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="allow_climber_app_profile_photo_update"
                       id="allowClimberAppProfilePhotoUpdateInput"
                       [(ngModel)]="orgConfig.allow_climber_app_profile_photo_update"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="allowClimberAppProfilePhotoUpdateInput">
                  Allow customers to update profile photos for themselves and their linked accounts
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.allow_climber_app_profile_photo_update }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, then a page will be available in the Climber App allowing customers to upload new profile photos for themselves and their linked accounts. When a customer uploads a new profile photo, an activity log entry will be created recording the event.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="enable_referral_codes"
                       id="enable_referral_codes"
                       [(ngModel)]="orgConfig.enable_referral_codes"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="enable_referral_codes">
                  Enable referral codes
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.enable_referral_codes }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, then a referral code will appear for each customer on the Climber App homepage, underneath their barcode. This referral can be provided during checkout for a membership in order record who referred the customer.
                <br>
                <a routerLink="/membership-settings/discounts" target="_blank">Discounts</a> can also be configured to automatically apply when a referral occurs.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="allow_climber_app_visit_history"
                       id="allowClimberAppVisitHistoryInput"
                       [(ngModel)]="orgConfig.allow_climber_app_visit_history"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="allowClimberAppVisitHistoryInput">
                  Allow customers to view and export their check-in history in the Climber App
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.allow_climber_app_visit_history }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, customers will see a "Visit History" page in the Climber App where they can view a paginated list of their check-ins and download the full history as a CSV.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="display_remaining_capacity_in_climber_app_listings"
                       id="displayRemainingCapacityInClimberAppListingsInput"
                       [(ngModel)]="orgConfig.display_remaining_capacity_in_climber_app_listings"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="displayRemainingCapacityInClimberAppListingsInput">
                  Show remaining capacity ("spots open") in Climber App event listings
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.display_remaining_capacity_in_climber_app_listings }}</div>
              </div>
              <small class="form-text text-muted">
                When selected, each event on the Climber App schedule shows how many spots are still open. This can be overridden for individual event types on the event type edit page.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="recaptcha_enabled"
                       id="recaptcha_enabled"
                       [(ngModel)]="orgConfig.recaptcha_enabled"
                       (ngModelChange)="unsavedChanges = true">
                <label class="form-check-label" for="recaptcha_enabled">
                  Enable reCAPTCHA to protect against bots
                </label>
                <div class="form-text text-danger">{{ orgConfigErrors.recaptcha_enabled }}</div>
              </div>
              <small class="form-text text-muted">
                If this option is selected, then reCAPTCHA will be used to prevent bots from creating customer accounts and attempting to make purchases. This can help protect against fraudulent behavior such as credit card testing.
                <br>
                CAPTCHA prompts will only be shown to users which are flagged as potential bots. The majority of your customers will not be impacted by this setting.
              </small>
            </div>

            <div class="alert alert-danger" role="alert" *ngIf="orgConfigErrors.non_field_errors">
              {{ orgConfigErrors.non_field_errors }}
            </div>
          </form>

          <hr>

          <h3 id="integrations">Integrations</h3>

          <div class="alert alert-info" *ngIf="apiService.inPinMode">
            New integrations cannot be connected in PIN Mode. In order to deactivate PIN Mode, log out and ensure the "Require PINs when making changes" option is not selected when logging back in.
          </div>

          <!--suppress TypeScriptValidateTypes -->
          <div class="mt-3" *ngIf="[OrgPOSSoftware.none, OrgPOSSoftware.lightspeed].includes(orgConfig.pos_software)">
            <p class="mb-1">
              Lightspeed Integration Status:
              <span *ngIf="loadingAnyClearConnection()" class="text-muted">Loading...</span>
              <span *ngIf="!loadingAnyClearConnection() && (orgConfig.pos_software === OrgPOSSoftware.none)" class="text-muted">Not connected</span>
              <span *ngIf="!loadingAnyClearConnection() && (orgConfig.pos_software === OrgPOSSoftware.lightspeed)" class="text-success"><b>Connected</b></span>
            </p>

            <a *ngIf="orgConfig.pos_software === OrgPOSSoftware.none"
               [href]="getLightspeedOAuthInitURL()"
               [class.disabled]="loadingAnyClearConnection() || apiService.inPinMode"
               class="btn btn-primary">
              Connect with Lightspeed
            </a>
            <div *ngIf="orgConfig.pos_software === OrgPOSSoftware.lightspeed">
              <button (click)="openSetLightspeedLocationMapModal()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                Link Locations
              </button>
              <button (click)="openSetLightspeedCustomerGroupsManagedByCapitanModal()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                Manage Customer Groups
              </button>
              <button (click)="openSetCapitanLightspeedUserModal()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                Set Capitan Lightspeed User
              </button>
              <button (click)="handleDisconnectLightspeedAccount()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-danger">
                Disconnect Lightspeed Account
              </button>
            </div>

            <div class="alert alert-warning mt-2" role="alert"
                 *ngIf="(orgConfig.pos_software === OrgPOSSoftware.lightspeed) && orgConfig.lightspeed_sync_error">
              <b>This integration needs attention.</b> {{ orgConfig.lightspeed_sync_error }}
            </div>

            <div class="alert alert-danger mt-2" role="alert" *ngIf="disconnectLightspeedAccountErrorMessage">
              {{ disconnectLightspeedAccountErrorMessage }}
            </div>
          </div>

          <!--suppress TypeScriptValidateTypes -->
          <div class="mt-3" *ngIf="[OrgPOSSoftware.none, OrgPOSSoftware.square].includes(orgConfig.pos_software)">
            <p class="mb-1">
              Square Integration Status:
              <span *ngIf="loadingAnyClearConnection()" class="text-muted">Loading...</span>
              <span *ngIf="!loadingAnyClearConnection() && (orgConfig.pos_software === OrgPOSSoftware.none)" class="text-muted">Not connected</span>
              <span *ngIf="!loadingAnyClearConnection() && (orgConfig.pos_software === OrgPOSSoftware.square)" class="text-success"><b>Connected</b></span>
            </p>

            <a *ngIf="orgConfig.pos_software === OrgPOSSoftware.none"
               [href]="getSquareOAuthInitURL()"
               [class.disabled]="loadingAnyClearConnection() || apiService.inPinMode"
               class="btn btn-primary">
              Connect with Square
            </a>
            <div *ngIf="orgConfig.pos_software === OrgPOSSoftware.square">
              <button (click)="openSetSquareLocationMapModal()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                Link Locations
              </button>
              <button (click)="openSetSquareCustomerGroupsManagedByCapitanModal()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                Manage Customer Groups
              </button>
              <button (click)="handleDisconnectSquareAccount()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-danger">
                Disconnect Square Account
              </button>
            </div>

            <div class="alert alert-warning mt-2" role="alert"
                 *ngIf="(orgConfig.pos_software === OrgPOSSoftware.square) && orgConfig.square_sync_error">
              <b>This integration needs attention.</b> {{ orgConfig.square_sync_error }}
            </div>

            <div class="alert alert-danger mt-2" role="alert" *ngIf="disconnectSquareAccountErrorMessage">
              {{ disconnectSquareAccountErrorMessage }}
            </div>
          </div>

          <div class="mt-3">
            <p class="mb-1">
              Mailchimp Integration Status:
              <span *ngIf="loadingAnyClearConnection()" class="text-muted">
                Loading...
              </span>
              <span *ngIf="!loadingAnyClearConnection() && !orgConfig.has_mailchimp_integration" class="text-muted">
                Not connected
              </span>
              <ng-container *ngIf="!loadingAnyClearConnection() && orgConfig.has_mailchimp_integration">
                <ng-container *ngIf="orgConfig.mailchimp_audience_id === ''">
                  <span *ngIf="orgConfig.mailchimp_audience_id_pending_sync === ''" class="text-warning">
                    <b>Connected, No Audience Selected</b>
                  </span>
                  <span *ngIf="orgConfig.mailchimp_audience_id_pending_sync !== ''" class="text-secondary">
                    <b>Connected, Audience Sync In Progress</b>
                  </span>
                </ng-container>
                <span *ngIf="orgConfig.mailchimp_audience_id !== ''" class="text-success">
                  <b>Connected, Selected Audience: {{ orgConfig.mailchimp_audience_name }}</b>
                </span>
              </ng-container>
            </p>

            <a *ngIf="!orgConfig.has_mailchimp_integration"
               [href]="getMailchimpOAuthInitURL()"
               [class.disabled]="loadingAnyClearConnection() || apiService.inPinMode"
               class="btn btn-primary">
              Connect with Mailchimp
            </a>
            <div *ngIf="orgConfig.has_mailchimp_integration">
              <button (click)="openSetMailchimpAudienceModal()" *ngIf="orgConfig.mailchimp_audience_id_pending_sync === ''"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-primary mr-2">
                {{ orgConfig.mailchimp_audience_id === '' ? 'Select Audience' : 'Change Audience' }}
              </button>
              <button (click)="handleDisconnectMailchimpAccount()"
                      [disabled]="loadingAnyClearConnection()" [class.disabled]="loadingAnyClearConnection()"
                      class="btn btn-danger">
                Disconnect Mailchimp account
              </button>
              <button (click)="handleResyncMailchimpGroups()"
                      [disabled]="!canResyncMailchimpGroups()"
                      [class.disabled]="!canResyncMailchimpGroups()"
                      class="btn btn-primary ml-2">
                {{ loadingResyncMailchimpGroups ? 'Loading...' : 'Resync Mailchimp groups' }}
              </button>
            </div>

            <div class="alert alert-warning mt-2" role="alert"
                 *ngIf="orgConfig.has_mailchimp_integration && orgConfig.mailchimp_sync_error">
              <b>This integration needs attention.</b> {{ orgConfig.mailchimp_sync_error }}
            </div>

            <div class="alert alert-danger mt-2" role="alert" *ngIf="mailchimpErrorMessage">
              {{ mailchimpErrorMessage }}
            </div>

            <div class="alert alert-success mt-2" role="alert" *ngIf="mailchimpSuccessMessage">
              {{ mailchimpSuccessMessage }}
            </div>
          </div>

          <div class="row" *ngIf="orgConfig.has_mailchimp_integration">
            <div class="col-md-8 col-lg-6 col-xl-4">
              <div class="mt-3">
                <label for="mailchimp_sync_window">
                  Mailchimp Customer Sync Window
                </label>
                <select class="custom-select"
                        id="mailchimp_sync_window" name="mailchimp_sync_window"
                        [(ngModel)]="orgConfig.mailchimp_sync_window"
                        (ngModelChange)="saveMailchimpConfig()">
                  <option [ngValue]="MailchimpSyncWindow.all">All</option>
                  <option [ngValue]="MailchimpSyncWindow.last12Months">Checked In Within Last 12 Months</option>
                </select>
                <small class="form-text text-muted">
                  This setting can be used to restrict which customers are synced to Mailchimp.
                </small>
              </div>
              <div class="mt-3">
                <label for="mailchimp_sync_transactional">
                  Sync Transactional Customers to Mailchimp?
                </label>
                <select class="custom-select"
                        id="mailchimp_sync_transactional" name="mailchimp_sync_transactional"
                        [(ngModel)]="orgConfig.mailchimp_sync_transactional"
                        (ngModelChange)="saveMailchimpConfig()">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
                <small class="form-text text-muted">
                  If "Yes", customers which are not opted into marketing communications will still be synced to Mailchimp, but will be configured as "transactional only".
                </small>
              </div>
            </div>
          </div>

          <p class="text-muted mt-3">
            To learn more, see our
            <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
               target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
          </p>
        </div>
      </ng-container>

      <div class="floating-alert-container">
        <div class="alert alert-success alert-dismissible" role="alert" *ngIf="floatingSuccessMessage">
          {{ floatingSuccessMessage }}
          <button type="button" class="close" (click)="floatingSuccessMessage = ''">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="floatingErrorMessage">
          {{ floatingErrorMessage }}
          <button type="button" class="close" (click)="floatingErrorMessage = ''">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="alert alert-info" role="alert" *ngIf="isSavingChanges()">
          Saving changes...
        </div>
      </div>
    </div>
  </div>
</div>
